import React, { useState } from 'react'

import { makeStyles } from '@material-ui/core/styles'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  table: {
    
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  autoCell: {
    width: 'auto'
  },
  compactCell: {
    padding: '3px',
    marginRight: theme.spacing(),
  },
  lastCell: {
    borderBottom: 'none',
  },
}))

const SimpleTable = ({
  data,
  fields,
  pagination,
  hideHeaderIfEmpty,
  compact,
  disableLastBorder,
  equalSpacing,
  getActions,
  onRowClick,
}) => {
  const classes = useStyles()

  const [ page, setPage ] = useState(0)
  const [ rowsPerPage, setRowsPerPage ] = useState(25)

  const handleChangePage = (event, page) => setPage(page)
  const handleChangeRowsPerPage = event => setRowsPerPage(event.target.value)

  const getCellClassname = (field, isLastCell) => {
    return [
      field && field.className ? field.className : classes.autoCell,
      compact ? classes.compactCell : null,
      isLastCell && disableLastBorder ? classes.lastCell : null,
    ].filter(c => c).join(' ')
  }

  const getCellStyle = (fields, field) => {
    if(equalSpacing) {
      return {
        width: `${100 / fields.length + getActions ? 1 : 0}%`,
      }
    }
    else if(field && field.width) {
      return {
        width: field.width,
      }
    }
    else {
      return {}
    }
  }

  const displayData = pagination ?
    data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) :
    data

  return (
    <div className={classes.root}>
      <div className={classes.tableWrapper}>
        <Table className={classes.table}>
          {
            (!hideHeaderIfEmpty || data.length > 0) && (
              <TableHead>
                <TableRow>
                  {
                    fields.map((field, i) => {
                      return (
                        <TableCell 
                          key={ i } 
                          align={ field.numeric ? 'right' : 'left' }
                          className={ getCellClassname(field) }
                          style={ getCellStyle(fields, field) }
                        >
                          { field.title }
                        </TableCell>
                      )
                    })
                  }
                  {
                    getActions ? (
                      <TableCell align='right' style={ getCellStyle(fields) }>
                        Actions
                      </TableCell>
                    ) : null
                  }
                </TableRow>
              </TableHead>
            )
          }
          <TableBody>
            {displayData.map((dataRow, rowIndex) => {
              return (
                <TableRow
                  hover
                  onClick={event => {
                    if(!onRowClick) return
                    onRowClick(event, dataRow.id)
                  }}
                  tabIndex={-1}
                  key={dataRow.id}
                >
                  {
                    fields.map((field, i) => {
                      return (
                        <TableCell 
                          key={ i } 
                          align={ field.numeric ? 'right' : 'left' } 
                          className={ getCellClassname(field, rowIndex == data.length - 1) }
                          style={ getCellStyle(fields, field) }
                        >
                          { dataRow[field.name] }
                        </TableCell>
                      )
                    })
                  }
                  {
                    getActions ? (
                      <TableCell
                        align='right'
                        className={ getCellClassname(null, rowIndex == data.length - 1) }
                        style={ getCellStyle(fields) }
                      >
                        { getActions(dataRow) }
                      </TableCell>
                    ) : null
                  }
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
      {
        pagination && (
          <TablePagination
            component="div"
            count={data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              'aria-label': 'Previous Page',
            }}
            nextIconButtonProps={{
              'aria-label': 'Next Page',
            }}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        )
      }
    </div>
  )
}

export default SimpleTable